import { Box, Text, Grid } from 'theme-ui';

import KitVariantProductCard from '~/components/Collection/Page/KitVariantProductCard';
import useNavigationHeight from '~/context/NavigationContext/useNavigationHeight';
import { breakpoints } from '~/gatsby-plugin-theme-ui/old-theme';

const CollectionRow = ({ itemList, category, collection, backgroundColor, validateChildren }) => {
  const { navHeight } = useNavigationHeight();
  const mdQuery = `@media screen and (max-width: ${breakpoints[0] - 1}px)`;
  const topValue = `${navHeight ?? 70 - 1}px`;

  return (
    <Box
      sx={{
        gridColumn: '3 span',
        mt: ['-2.4rem', 0],
        px: ['1.9rem', '3rem'],
        '.content': { height: '100%' },
        '.content .header': {
          [mdQuery]: {
            width: '100vw',
            ml: '-2.4rem',
            pl: '2.4rem',
            height: 'auto',

            position: 'sticky',
            backgroundColor: backgroundColor,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            mb: 0,
          },
        },
      }}
    >
      <Box className="content" sx={{ position: 'relative', width: '100%;' }}>
        {category && (
          <Box
            className="header"
            sx={{
              py: ['1.2rem', 0],
              zIndex: 2,
              letterSpacing: '-0.04em',
              fontSize: ['2.8rem', '3.6rem'],
              mb: [0, '2.4rem'],
              lineHeight: ['1em', '3.2rem'],
              textTransform: 'uppercase',
              fontWeight: 'medium',
            }}
            style={{ top: topValue }}
          >
            <Text data-testid="category-title">{category}</Text>
          </Box>
        )}
        {itemList && (
          <Grid
            sx={{
              mb: ['1.6rem', 0],
              gap: '2.5rem',
              gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
              position: 'relative',
            }}
          >
            {itemList.map((item) => {
              if (!validateChildren(item?.content?.__typename)) return null;
              const cardCollection = collection ?? item?.content?.collection?.[0];
              return (
                <KitVariantProductCard
                  key={item.id}
                  cdpCopy={item.copy}
                  item={item.content}
                  collectionSlug={cardCollection?.slug}
                  cardDirection={item.cardDirection}
                  isFeaturedCard={item.isFeaturedCard}
                  {...item}
                />
              );
            })}
          </Grid>
        )}
      </Box>
    </Box>
  );
};
CollectionRow.defaultProps = {
  validateChildren: () => true,
};

export default CollectionRow;
